import { render, staticRenderFns } from "./questionsRate.vue?vue&type=template&id=3591af1b&scoped=true"
import script from "./questionsRate.vue?vue&type=script&lang=js"
export * from "./questionsRate.vue?vue&type=script&lang=js"
import style0 from "./questionsRate.vue?vue&type=style&index=0&id=3591af1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3591af1b",
  null
  
)

export default component.exports